import {TransportCardInfo} from '../../../models/api/transportCardInfo';

const mockResponse: TransportCardInfo = {
  number: '22 01949491 ',
  isActive: true,
  seria: {
    code: 1,
    name: 'seria',
  },
  type: {
    code: 2,
    name: 'Месячный проездной билет для граждан автобус + троллейбус',
  },
  state: {
    code: 3,
    description: 'state',
  },
  lastTripDate: '2022-03-04T05:56:43.926Z',
  validToDate: '2022-03-04T05:56:43.926Z',
};

export default mockResponse;
